"use client";
import clsx from 'clsx';
import { useState } from "react";
import AnimatedLink from '../animated-link'
import Underline from "../svg/underline";

export default function NavLink({ underlineScale = 1, label, href, underlineSize, isActive, onHoverChange, onClick, transitionName = "base", className = "", ...props }) {
  const [isHover, setIsHover] = useState(false);

  const handlePointerEnter = () => {
    setIsHover(true);
    if (onHoverChange) {
      onHoverChange(true);
    }
  };

  const handlePointerLeave = () => {
    setIsHover(false);
    if (onHoverChange) {
      onHoverChange(false);
    }
  };

  return (
    <AnimatedLink
      href={href}
      className={clsx(className, "subnav lg:heading-7 relative flex flex-col items-center")}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      transitionName={transitionName}
      onClick={onClick}
      {...(isActive && { "data-current": "page" })}
      label={label}
      {...props}
    >
      <span>{label}</span>
      <Underline
        className={clsx("absolute -bottom-(--space-4) pointer-events-none")}
        scale={underlineScale}
        size={underlineSize}
        isHover={isHover}
        isActive={isActive}
      />
    </AnimatedLink>
  );
}
